export const translations = {
    en: {
        imprint: {
            title: 'Imprint',
            associationName: 'Association Name & Address',
            paragraph: 'Information according to § 5 German Telemedia Act (TMG) and § 18 (2) State Media Treaty (MStV)',
            authorizedBoardMembers: 'Authorized Board Members',
            copyrightTitle: 'Copyright',
            copyrightText: 'All content and works created by the association on these pages are subject to German copyright law.\n' +
                'Downloads and copies of this site are permitted for private, non-commercial use only.',
            liabilityForContentTitle: 'Liability for Content',
            liabilityForContentText: 'As a service provider, we are responsible for our own content on these pages in accordance with § 7 (1) TMG and general legislation.\n' +
                'However, according to §§ 8 to 10 TMG, we are not obligated to monitor transmitted or stored third-party information or to investigate circumstances indicating illegal activity.',
            registerEntryTitle: 'Register Entry',
        },
        footer: {
            bylaws: 'Bylaws',
            membershipFeeRegulations: 'Membership Fee Regulations',
        },
        nav: {
            home: 'Home',
            about: 'Who We Are',
            management: 'Our Board',
            coaches: 'Coaches',
            schedule: 'Schedule',
            faq: 'FAQ',
            burn: 'Phoenix Burn',
            donate: 'Support Us',
            contact: 'Contact'
        },
        hero: {
            title: 'Together We Rise!',
            subtitle: 'Burn. Rise. Repeat.',
            cta: 'Join Our Movement'
        },
        about: {
            title: 'Who We Are',
            subtitle: 'Who are we - and what do we actually do?',
            content: [
                'We are Phoenix Athletics e.V., a young sports club from Neu-Ulm - right on the border to Ulm - with a great passion for Functional Fitness - and for people.',
                'But with us, it\'s about more than just weights and repetitions.',
                'We train together - indoors, outdoors, with equipment or just with our own body weight.',
                'Everyone is welcome: beginners, sports enthusiasts, couch potatoes, those returning to fitness, or competitors.',
                'Our training sessions are varied, challenging, but always scaled for every fitness level and therefore doable for everyone. We celebrate progress, not perfection.',
                'In addition to classic workouts, we also offer mobility, running training, and community events where team spirit is paramount.',
                'Because we believe: Strong people build strong communities.',
                'And that\'s exactly what we want - to grow, become strong together, and lift each other up.',
                'Want to work out, have fun, and meet new people?',
                'Then: Welcome to Phoenix Athletics e.V.!'
            ]
        },
        schedule: {
            title: 'Our Training Schedule',
            note: 'All classes are suitable for all fitness levels. First timers welcome!',
            liveCta: 'View Live Schedule & Book'
        },
        faq: {
            title: 'FAQ',
            subtitle: 'Frequently Asked Questions',
            items: [
                {
                    q: 'Is Phoenix Athletics a CrossFit box in Ulm?',
                    a: 'Phoenix Athletics is not an officially licensed CrossFit affiliate - we are an independent non-profit sports club for Functional Fitness. That said, several of our coaches hold CrossFit certifications and competition experience, and our training draws on the same functional, varied approach to fitness.'
                },
                {
                    q: 'Who is the training suitable for?',
                    a: 'Everyone - beginners, returning athletes, competitors, and anyone in between. Every session is scaled to individual fitness levels, so it\'s doable no matter where you\'re starting from.'
                },
                {
                    q: 'How can I try a session or become a member?',
                    a: 'You can register or book directly through our Booklyfit booking system, linked at the top of this page, or reach out to us via email or Instagram.'
                }
            ]
        },
        management: {
            title: 'Our Board',
            subtitle: 'Meet the dedicated leadership team guiding Phoenix Athletics'
        },
        coaches: {
            title: 'Our Coaches',
            subtitle: 'Meet the passionate team behind your fitness journey',
            showMore: 'Read More',
            showLess: 'Show Less'
        },
        contact: {
            title: 'Get in Touch',
            findUs: 'Find us on Instagram for the latest updates, workout tips, and community events!',
            followUs: 'Join our Phoenix Athletics community today!'
        },
        burn: {
            eyebrow: 'Our First Event',
            title: 'Phoenix Burn 2026',
            date: 'October 17, 2026',
            location: 'Ehinger Straße 19, 89073 Ulm',
            description: 'On October 17, 2026, Ulm is on fire! Phoenix Burn is our very first own event: a mixed-team competition for everyone who\'s up for tough workouts, real team spirit, and an incredible atmosphere. Compete in the Elite or Challenger division, bring your team to the line, and support us along the way with our Pay-per-Rep Challenge. Be part of it - as an athlete, sponsor, or fan!',
            cta: 'Register Now'
        },
        donate: {
            eyebrow: 'Friends & Supporters',
            title: 'Help Us Grow Phoenix Athletics!',
            description: 'We\'re growing - our equipment, unfortunately, not quite as fast. As a donor or supporter, you help us provide better training conditions and new projects for our community.',
            cta: 'Support Us Now'
        },
        announcement: {
            text: 'New: Our booking system is live!',
            cta: 'Register here',
            bookingCta: 'Book Now',
            membershipCta: 'Become a Member'
        }
    },
    de: {
        imprint: {
            title: 'Impressum',
            associationName: 'Vereinsname & Anschrift',
            paragraph: 'Angaben gemäß § 5 TMG und § 18 Abs. 2 MStV',
            authorizedBoardMembers: 'Vereinsname & Anschrift',
            copyrightTitle: 'Urheberrecht',
            copyrightText: 'Die durch den Verein erstellten Inhalte und Werke auf diesen Seiten unterliegen\n' +
                'dem deutschen Urheberrecht. Downloads und Kopien sind nur für den privaten,\n' +
                'nicht kommerziellen Gebrauch gestattet.',
            liabilityForContentTitle: 'Haftung für Inhalte',
            liabilityForContentText: 'Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf\n' +
                'diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG\n' +
                'sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen\n' +
                'zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.\n',
            registerEntryTitle: 'Registereintrag',
        },
        footer: {
            bylaws: 'Satzung',
            membershipFeeRegulations: 'Beitragsordnung',
        },
        nav: {
            home: 'Startseite',
            about: 'Über Uns',
            management: 'Vorstand',
            coaches: 'Coaches',
            schedule: 'Kursplan',
            faq: 'FAQ',
            burn: 'Phoenix Burn',
            donate: 'Unterstützen',
            contact: 'Kontakt'
        },
        hero: {
            title: 'Together We Rise!',
            subtitle: 'Burn. Rise. Repeat.',
            cta: 'Werde Teil der Community'
        },
        about: {
            title: 'Über Uns',
            subtitle: 'Wer sind wir - und was machen wir eigentlich?',
            content: [
                'Wir sind Phoenix Athletics e.V., ein junger Sportverein aus Neu-Ulm - direkt an der Grenze zu Ulm - mit einer großen Portion Leidenschaft für Functional Fitness - und für Menschen.',
                'Doch bei uns geht\'s um mehr als nur Gewichte und Wiederholungen.',
                'Wir trainieren gemeinsam - drinnen, draußen, mit Equipment oder nur mit dem eigenen Körpergewicht.',
                'Dabei ist jeder willkommen: Anfänger/-innen, Sportbegeisterte, Bewegungsmuffel, Wiedereinsteiger/-innen oder Wettkämpfer.',
                'Unsere Trainings sind abwechslungsreich, herausfordernd, aber immer für jedes Fitness-Level skalierbar und deshalb für jeden machbar. Wir feiern Fortschritte, keine Perfektion.',
                'Neben den klassischen Workouts bieten wir auch Lauf-Training und Community-Events, bei denen der Teamgeist ganz groß geschrieben wird.',
                'Denn wir glauben: Starke Menschen bauen starke Gemeinschaften.',
                'Und genau das wollen wir - wachsen, gemeinsam stark werden, einander mitziehen.',
                'Du willst dich auspowern, Spaß haben und neue Leute kennenlernen?',
                'Dann: Willkommen bei Phoenix Athletics e.V.!'
            ]
        },
        schedule: {
            title: 'Unsere Trainingszeiten',
            note: 'Alle Kurse sind für alle Fitness-Level geeignet. Anfänger willkommen!',
            liveCta: 'Live-Zeitplan ansehen & buchen'
        },
        faq: {
            title: 'FAQ',
            subtitle: 'Häufige Fragen',
            items: [
                {
                    q: 'Ist Phoenix Athletics eine CrossFit-Box in Ulm?',
                    a: 'Phoenix Athletics ist kein offiziell lizenziertes CrossFit-Affiliate, sondern ein eigenständiger, gemeinnütziger Sportverein für Functional Fitness. Mehrere unserer Coaches bringen jedoch CrossFit-Zertifizierungen und Wettkampferfahrung mit, und unser Training folgt einem ähnlich funktionellen, abwechslungsreichen Ansatz.'
                },
                {
                    q: 'Für wen eignet sich das Training bei Phoenix Athletics?',
                    a: 'Für jedes Fitnesslevel - von Anfänger/-innen über Wiedereinsteiger/-innen bis zu Wettkämpfer/-innen. Jede Einheit wird individuell skaliert, sodass sie unabhängig vom Ausgangsniveau machbar ist.'
                },
                {
                    q: 'Wie kann ich ein Probetraining machen oder Mitglied werden?',
                    a: 'Du kannst dich direkt über unser Booklyfit-Buchungssystem registrieren oder eine Einheit buchen, verlinkt oben auf der Seite - oder uns per E-Mail oder Instagram kontaktieren.'
                }
            ]
        },
        management: {
            title: 'Unser Vorstand',
            subtitle: 'Lerne das engagierte Führungsteam kennen, das Phoenix Athletics leitet'
        },
        coaches: {
            title: 'Unsere Coaches',
            subtitle: 'Lerne das leidenschaftliche Team hinter deiner Fitness-Reise kennen',
            showMore: 'Mehr lesen',
            showLess: 'Weniger anzeigen'
        },
        contact: {
            title: 'Kontaktieren Sie uns',
            findUs: 'Folgt uns auf Instagram für aktuelle Updates, workout-Tipps und Community-Events!',
            followUs: 'Werde Teil unserer Phoenix Athletics Community!'
        },
        burn: {
            eyebrow: 'Unser erstes Event',
            title: 'Phoenix Burn 2026',
            date: '17. Oktober 2026',
            location: 'Ehinger Straße 19, 89073 Ulm',
            description: 'Am 17. Oktober 2026 brennt Ulm! Der Phoenix Burn ist unser erstes eigenes Event: ein Mixed-Team-Wettkampf für alle, die Bock auf harte Workouts, Teamgeist und eine geile Atmosphäre haben. Tritt in der Elite- oder Challenger-Division an, bring dein Team an den Start – und unterstütze uns nebenbei mit unserer Pay-per-Rep Challenge. Sei dabei, als Athlet, Sponsor oder Fan!',
            cta: 'Jetzt anmelden'
        },
        donate: {
            eyebrow: 'Freunde & Förderer',
            title: 'Hilf uns, Phoenix Athletics auszubauen!',
            description: 'Wir wachsen – unser Equipment leider nicht ganz so schnell. Als Förderer oder mit einer Spende hilfst du uns, bessere Trainingsbedingungen und neue Projekte für unsere Community zu schaffen.',
            cta: 'Jetzt unterstützen'
        },
        announcement: {
            text: 'Neu: Unser Buchungssystem ist online!',
            cta: 'Hier registrieren',
            bookingCta: 'Jetzt buchen',
            membershipCta: 'Mitglied werden'
        }
        }
        };